const colors = [
  '#57E2FF',
  '#FF63A3',
  '#5EFF9E',
  '#FF8645',
  '#75FF52',
  '#3F6B8F',
  '#DB8F8C',
  '#77AEDB',
  '#D7DB60',
  '#8C8F46',
  '#A69C41',
  '#737266',
  '#DAB86B',
  '#A4C5DE',
  '#4195A6',
  '#7E68E8',
  '#4EF2D3',
  '#BEDB50',
  '#E8A9D7',
]

export default colors
